import { useQuery } from '@tanstack/react-query'
import api from '../../config/axios-config.jsx'
import { projectQueryKeys } from '../constants.js'
import { generateProjectPath } from '../../../utils/generateProjectPath.js'

export const useGetProjectPathQuery = ({ projectId, options = {} } = {}) => {
  const handleQuery = async () => {
    const { data } = await api(`/api/projectFolders/projects/${projectId}/path`)

    return generateProjectPath(data)
  }

  return useQuery({
    queryKey: [projectQueryKeys.GET_PROJECT_PATH_QUERY, projectId],
    queryFn: handleQuery,
    enabled: !!projectId,
    staleTime: Infinity,
    retry: 0,
    ...options
  })
}
